import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Avatar, Icon } from '@material-ui/core';
import { getComments, sendComment, setShowDeleteComment } from '../actions/CommentsActions';
import './Comments.scss';
import { UserChip } from './UserChip';
import ShoutoutImage from './ShoutoutImage';
import { CircleLoader } from './CircleLoader';
import Comment from './Comment';

class CommentsComponent extends Component {
  state = { message: '' };
  interval = null;
  commentsTextarea = null;
  commentsWrapper = null;
  userOptionsRefs = [];

  UNSAFE_componentWillMount() {
    const { shoutout, getComments } = this.props;

    getComments(shoutout._id);
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      this.setState({ ...this.state });
    }, 60000);
    this.commentsTextarea.style.height = '1px';
    this.commentsTextarea.style.height = `${this.commentsTextarea.scrollHeight}px`;
    if (window.innerWidth > 480) this.commentsTextarea.focus();
    this.scrollCommentsToBottom();
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // Once we receive the comments, scroll to the bottom
    if (!nextProps.commentsLoading && nextProps.comments &&
        ((nextProps.comments.length && !this.props.comments) ||
        (nextProps.comments.length !== this.props.comments.length))) {
      setTimeout(() => {
        this.scrollCommentsToBottom();
      }, 1);
    }
  }

  commentMessageChanged(event) {
    this.setState({ message: event.target.value });

    this.commentsTextarea.style.height = '1px';
    if (this.commentsTextarea.scrollHeight < 98) {
      this.commentsTextarea.style.height = `${this.commentsTextarea.scrollHeight}px`;
    } else {
      this.commentsTextarea.style.height = '108px';
    }
  }

  scrollCommentsToBottom() {
    if (this.commentsWrapper) {
      this.commentsWrapper.scrollTop = this.commentsWrapper.scrollHeight - this.commentsWrapper.clientHeight;
    }
  }

  checkEnter(event) {
    if (event.key === 'Enter') {
      event.preventDefault();

      if (this.state.message.length > 0 && this.state.message.length <= 250) {
        const { sendComment, shoutout } = this.props;

        sendComment(shoutout._id, this.state.message);

        this.setState({ message: '' });

        setTimeout(() => {
          this.commentsTextarea.style.height = '1px';
          this.commentsTextarea.style.height = `${this.commentsTextarea.scrollHeight}px`;
        }, 5);
      }
    }
  }

  confirmDelete(comment) {
    this.props.setShowDeleteComment(comment);
  }

  renderDate(date) {
    return moment(date).format('M•D•YYYY - h:mm A');
  }

  renderComments() {
    const { comments, commentsLoading, currentUser } = this.props;

    if (commentsLoading) {
      return (
        <div className="comment-wrapper">
          <div className="comments-empty">
            <CircleLoader />
          </div>
        </div>
      );
    } else if (comments && comments.length === 0) {
      return (
        <div className="comment-wrapper">
          <div className="comments-empty">
            No comments here. Why don't you leave one?
          </div>
        </div>
      );
    } else {
      return this.props.comments.map((comment, i) => (
        <Comment
          onDeleteClicked={this.confirmDelete.bind(this)}
          currentUser={currentUser}
          isAdmin={currentUser.role === 'super_admin' || currentUser.role === 'admin'}
          comment={comment}
          key={i}
        />
      ));
    }
  }

  render() {
    const { message } = this.state;
    const { shoutout, currentUser, closeModal } = this.props;

    if (shoutout) {
      const photoURL = currentUser ? currentUser.picture : '';

      return (
        <div className="comment-modal-content">
          <Icon onClick={() => { if (closeModal) closeModal(); }} className="back-arrow">arrow_right_alt</Icon>
          <div className="comments-shoutout-wrapper">
            <div className="comments-shoutout-time">{this.renderDate(shoutout.date)}</div>
            <div className="comments-shoutout-recipients">
              <div className="comments-shoutout-recipients-to">To:</div>
              {shoutout.recipients.map((recipient, i) => (<UserChip key={i} user={recipient} extraText={i < shoutout.recipients.length - 1 ? ', ' : ''} />))}
            </div>
            <div className="comments-shoutout-text" dangerouslySetInnerHTML={{ __html: shoutout.text }}></div>

            <ShoutoutImage screen="comments" shoutout={shoutout}/>

            <div className="comments-shoutout-sender">
              <div className="comments-shoutout-recipients-to">From:</div>
              <UserChip user={shoutout.sender} />
              <div className="comments-badge">
                <Icon className="icon" style={{ color: '#faa85f' }}>chat_bubble</Icon>
                {shoutout.comments.length}
              </div>
            </div>
          </div>
          <div className="comments-wrapper" ref={(ref) => this.commentsWrapper = ref}>
            {this.renderComments()}
          </div>
          <div className="comments-footer">
            <Avatar className="comments-footer-user-icon" alt="" src={photoURL} />
            <div className="comments-textarea-wrapper">
              <textarea
                ref={(ref) => this.commentsTextarea = ref}
                placeholder="Leave a Comment"
                value={message}
                onChange={this.commentMessageChanged.bind(this)}
                className="comments-textarea"
                onKeyPress={this.checkEnter.bind(this)}
              />
              <div className="comments-textarea-counter" style={{ display: (message.length === 0 ? 'none' : 'block'),
                color: (message.length > 250 ? '#d0021b' : '#b1b0b0') }}>
                {message.length}/250
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = ({ commentsStore, usersStore }, ownProps) => {
  const { comments, commentsLoading } = commentsStore;
  const { currentUser } = usersStore;
  const { shoutout } = ownProps;
  let currentComments = [];
  if (shoutout && comments[shoutout._id]) currentComments = comments[shoutout._id];

  return { comments: currentComments, currentUser, commentsLoading };
};

const Comments = connect(mapStateToProps, { getComments, sendComment, setShowDeleteComment })(CommentsComponent);

export { Comments };



// WEBPACK FOOTER //
// ./src/components/Comments.js